export default __webpack_public_path__ + "static/media/group_people.750b7a5e.svg";